<template>
  <div>
    <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_SplitExpense')" :show-close="false" width="400px" @close="cancel">
      <div class="app-main-inner-row">
        <el-form :inline="true" label-position="left" label-width="70px" :model="charge">
          <el-form-item :label="$t('Billing.billingJob_businessNumber')">
            <el-input v-model="charge.jobJobNo" :disabled="true" no="1" />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingJob_chargeItem')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_ChargeItem"
              no="2"
              filterable
              :default-value="charge.chargeChargeItemId"
              :disabled="true"
              style="width:165px;"
            />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingCharge_currency')">
            <el-input v-model="charge.chargeCurrency" :disabled="true" no="3" />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingCharge_taxIncludedPrice')">
            <el-input v-model="charge.chargeAmount" :disabled="true" no="4" />
          </el-form-item>
          <el-form-item>
            <span style="width: 235px;color: red">{{ $t('CargoMsg.Cargo_PETSFIIB') }}</span>
          </el-form-item>
          <el-form-item :label="$t('Billing.billingCharge_taxIncludedPrice')">
            <el-input-number v-model="amount" no="5" :controls="false" style="width: 165px;" />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingJob_chargeItem')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_ChargeItem"
              no="6"
              filterable
              :default-value="chargeItemId"
              style="width:165px;"
              @parentCallBack="item => this.chargeItemId = item.itemId"
            />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingJob_settlementCompany')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              no="7"
              :default-value="accountId"
              style="width:165px;"
              @parentCallBack="item => this.accountId = item.cmpIdx"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" no="8" size="mini" @click="successEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
        <el-button size="mini" no="9" @click="cancel">{{ $t('Billing.billingView_Close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { splitCharge } from '@/api/clearing/charge'

export default {
  name: 'ChargeSplitByChargeDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    oldCharge: { type: Object, required: true }, // 弹框打开时默认传递条件
    viewSource: { type: String, required: true }, // 请求来源
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      charge: this.oldCharge,
      amount: 0,
      chargeItemId: this.oldCharge ? this.oldCharge.chargeChargeItemId : '',
      accountId: this.oldCharge ? this.oldCharge.chargeAccountId : '',
      selectTypeNames: TYPE_NAMES
    }
  },
  computed: {},
  created() {
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      const viewSource = this.viewSource
      if (viewSource === 'billingDetail') {
        this.$emit('chargeSplitByChargeCallBackEvent', false)
      }
    },
    successEvent() {
      const viewSource = this.viewSource
      const charge = this.charge
      const amount = this.amount
      const chargeItemId = this.chargeItemId
      const accountId = this.accountId
      if (!amount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_InputTaxAmount'))
        return
      }
      if (!charge) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (!chargeItemId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseFeeName'))
        return
      }
      if (!accountId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseSettlementEntity'))
        return
      }
      splitCharge({ sourceChargeUuid: charge['uuid'], amount: amount, chargeItemId: chargeItemId, accountId: accountId, location: this.location }).then(res => {
        if (viewSource === 'billingDetail') {
          this.$emit('chargeSplitByChargeCallBackEvent', true)
        }
      }).finally(() => {})
    }
  }
}
</script>
